import React, { useMemo, useState } from "react";
import { FormGroup } from "components/common";
import { Badge, Button, ModalBody, ModalFooter, Table } from "reactstrap";
import { Trans } from "react-i18next";
import { Control, LocalForm } from "react-redux-form";
import Select from "react-select";
import { NotificationManager } from "react-notifications";


export const InviteEmployees = ({
    t,
    toggle,
    listInvitedEmployees,
    employeeOptions,
    list_id,
    client,
    selectedOrganisation,
    getInvitedEmployees,
}) => {
    const [handleInviteEmployees, setHandleInviteEmployees] = useState({ invitedEmployees: true, inviteEmployees: false, selectedEmployees: [], updateInvitedEmployees: false });

    const inviteEmployeesFunction = () => {
        setHandleInviteEmployees(prevState => ({
            ...prevState,
            inviteEmployees: !prevState.inviteEmployees,
            updateInvitedEmployees: false,
        }));
    };

    const startEditEmployee = (employeeRow) => {
        if (!employeeRow?.employee) return;
        setHandleInviteEmployees(prevState => ({
            ...prevState,
            selectedEmployees: [employeeRow],
            updateInvitedEmployees: true,
            inviteEmployees: false,
        }));
    };

    const cancelUpdateEmployee = () => {
        setHandleInviteEmployees(prevState => ({
            ...prevState,
            selectedEmployees: [],
            updateInvitedEmployees: false,
        }));
    };

    const getPermissionOptions = () => {
        return [
            { label: "Can edit items", value: "Can edit items" },
            { label: "Can view", value: "Can view" },
        ];
    };

    const handleInviteEmployeesSubmit = async (values) => {

        try {
            const response = await client.put(
                `streak-list/${selectedOrganisation.id}/invite-employees/${list_id}/invite_employees`,
                values
            );
            toggle();
            NotificationManager.success("Employees invited to list successfully");

            setTimeout(() => {
                getInvitedEmployees();
            }, 1000);
        } catch (error) {
            if (error.response && error.response.data && error.response.data.error) {
                NotificationManager.error(error.response.data.error);
            } else {
                NotificationManager.error("Something went wrong");
            }
        };
        toggle();
    };

    const getEmployeesOptions = useMemo(() => {
        if (!employeeOptions) return [];
        return employeeOptions.map(employee => ({
            label: employee?.full_name,
            value: employee?.id,
        }));
    }, [employeeOptions]);

    return (
        <>
            <div className="modal-header">
                <div className="">
                    {handleInviteEmployees.invitedEmployees && (
                        <div className="">
                            <Trans>Invite Employees</Trans>
                        </div>
                    )}
                    <div className="mt-2">
                        <Badge color="info" pill>
                            <h6 className="font-weight-normal m-0"><span><i className="fa fa-users" aria-hidden="true"></i></span> {listInvitedEmployees?.employees?.length} <Trans>People</Trans></h6>
                        </Badge>
                    </div>
                </div>
            </div>
            <ModalBody>
                <div>
                    {handleInviteEmployees.invitedEmployees && (
                        <>
                            <Table hover className="border">
                                <tbody>
                                    {listInvitedEmployees?.employees && listInvitedEmployees?.employees?.map((user, index) => (
                                        <tr key={index} onClick={() => startEditEmployee(user)}>
                                            <td>
                                                <div className="d-flex justify-content-between clickable">
                                                    <div className="class">
                                                        {user?.user__full_name ? user?.user__full_name : user?.employee__full_name}
                                                    </div>
                                                    <div className="class">
                                                        {user?.permission}
                                                    </div>
                                                </div>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </Table>
                        </>
                    )}
                </div>
                {handleInviteEmployees.updateInvitedEmployees && (
                    <div className="w-100 col float-right d-contents border p-2 mt-2">
                        <LocalForm
                            className={`col-12 col-md-10 col-lg-12 col-xl-12 `}
                            onSubmit={(values) => handleInviteEmployeesSubmit(values)}
                            model="inviteForm"
                            initialState={{
                                employee: handleInviteEmployees.selectedEmployees?.[0]?.employee,
                                permission: handleInviteEmployees.selectedEmployees?.[0]?.permission,
                            }}
                        >
                            <>
                                <div className="d-flex justify-content-between align-items-center">
                                    <div>
                                        <FormGroup
                                            label={``}
                                            addControlClass={false}
                                        >
                                            <Control.text
                                                model={`inviteForm.employee`}
                                                component={Select}
                                                options={getEmployeesOptions}
                                                simpleValue
                                            />
                                        </FormGroup>
                                    </div>
                                    <div className="mx-2" />
                                    <div className="w-50">
                                        <FormGroup
                                            addControlClass={false}
                                            label={``}
                                        >
                                            <Control.text
                                                model={`inviteForm.permission`}
                                                component={Select}
                                                simpleValue
                                                options={getPermissionOptions()}
                                            />
                                        </FormGroup>
                                    </div>
                                </div>
                                <div className="mt-4 text-right">
                                    <FormGroup>
                                        <Button className="mr-2" color="secondary" type="button" onClick={cancelUpdateEmployee}>
                                            <Trans>Cancel</Trans>
                                        </Button>
                                        <Button className="m-0" color="primary" type="submit">
                                            <Trans>Update</Trans>
                                        </Button>
                                    </FormGroup>
                                </div>
                            </>
                        </LocalForm>
                    </div>
                )}
                {handleInviteEmployees.inviteEmployees && (
                    <div className="w-100 col float-right d-contents border p-2 mt-2">
                        <LocalForm
                            onSubmit={(values) => handleInviteEmployeesSubmit(values)}
                            model="inviteForm"
                            initialState={{}}
                        >
                            <>
                                <div className="row">
                                    <div className="col-8">
                                        <FormGroup
                                            label={``}
                                            addControlClass={false}
                                        >
                                            <Control.text
                                                model={`inviteForm.employee`}
                                                component={Select}
                                                options={getEmployeesOptions}
                                                simpleValue
                                            />
                                        </FormGroup>
                                    </div>
                                    <div className="col-4">
                                        <FormGroup
                                            addControlClass={false}
                                            label={``}
                                        >
                                            <Control.text
                                                model={`inviteForm.permission`}
                                                component={Select}
                                                simpleValue
                                                options={getPermissionOptions()}
                                            />
                                        </FormGroup>
                                    </div>
                                </div>

                                <div className="mt-4 text-right">
                                    <FormGroup>

                                        <Button className="m-0" color="primary" type="submit">
                                            <Trans>Invite</Trans>
                                        </Button>
                                    </FormGroup>
                                </div>
                            </>


                        </LocalForm>
                    </div>
                )}
                {!handleInviteEmployees.inviteEmployees && !handleInviteEmployees.updateInvitedEmployees && (
                    <div className="mt-2">
                        <Button className="w-100 m-0" outline color="success" onClick={() => inviteEmployeesFunction()}>
                            <i className="fa fa-plus" aria-hidden="true"></i><Trans> Invite</Trans>
                        </Button>
                    </div>
                )}
            </ModalBody>
            <ModalFooter>
                <Button color="secondary" onClick={() => toggle()}>
                    <Trans>Close</Trans>
                </Button>
            </ModalFooter>
        </>
    );
};

export default InviteEmployees;
